<template>
  <Dialog
    header="How do I customize the script?"
    :draggable="false"
    v-model:visible="visible"
    :style="{width: '480px'}"
    :modal="true"
    @hide="close()"
  >
    <p>
      But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain. I will give you
      a complete account of the system.
    </p>

    <h6 class="help-title">How do I change the title?</h6>
    <p>
      But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer,
      the master-builder of human happiness.
    </p>
    <img src="../../../assets/images/help-hook-and-title.png" alt="Hook + Title" />

    <h6 class="help-title">How do I change the video duration?</h6>
    <p>
      But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer,
      the master-builder of human happiness.
    </p>
    <img src="../../../assets/images/help-duration.png" alt="Duration" />

    <h6 class="help-title">How do I add the text for the creator?</h6>
    <p>
      But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer,
      the master-builder of human happiness.
    </p>
    <img src="../../../assets/images/help-need-say.png" alt="Need a say" />

    <h6 class="help-title">How do I add the task for the creator?</h6>
    <p>
      But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer,
      the master-builder of human happiness.
    </p>
    <img src="../../../assets/images/help-hook-show.png" alt="Need a show" />

    <template #footer></template>
  </Dialog>
</template>

<script setup>
import {defineEmits, defineProps, reactive, ref, watch, onMounted, toRefs, computed, unref} from "vue";
import {useVModel} from "@vueuse/core";

const emit = defineEmits(['update:visible']);
const props = defineProps({
  visible: {type: Boolean, default: false, required: true},
});

const visible = useVModel(props, 'visible', emit)

const close = () => visible.value = false;

</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.help-title {
  margin-top: toRem(40);
  margin-bottom: toRem(12);
  font-weight: 600;
  font-size: toRem(18);
}

p {
  margin: 0;
  color: $textSecondaryColor;
}

img {
  margin-top: toRem(20);
}
</style>
